import { render, staticRenderFns } from "./WatchLives.vue?vue&type=template&id=ee49a0e2&scoped=true"
import script from "./WatchLives.vue?vue&type=script&lang=js"
export * from "./WatchLives.vue?vue&type=script&lang=js"
import style0 from "./WatchLives.vue?vue&type=style&index=0&id=ee49a0e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee49a0e2",
  null
  
)

export default component.exports